import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InvestmentHistory from "../components/InvestmentHistory";

const Investments = () => {
    const { t } = useTranslation();
    return (
        <Box sx={{ maxWidth: 900, mx: "auto", mt: 4, mb: 4 }}>
            <Typography variant="h4" sx={{ mb: 3 }}>{t("investments.title", "My Investments")}</Typography>
            <InvestmentHistory />
        </Box>
    );
};

export default Investments; 